export default __webpack_public_path__ + "static/media/plant2.f667c92c.png";